.section {
  display: flex;
  flex-direction: row;
  gap: var(--space-sm);
}
